import "./Home.module.css";
import GatewayHeader from "@/reusable_sections/Header";
import HeroShowcase from "./sections/HeroShowcase";
import OurCoreCompetencies from "./sections/OurCoreCompetencies";
import AboutRestaurant from "./sections/AboutRestaurant";
import ContactInformation from "./sections/ContactInformation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <GatewayHeader />
      <HeroShowcase />
      <OurCoreCompetencies />
      <AboutRestaurant />
      <ContactInformation />
      <Footer />
    </div>;
}